import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Car, PlusCircle, CheckCircle2, LogOut, User } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { toast } from 'sonner';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const links = [
    { path: '/dashboard', icon: Home, label: 'Tableau de bord' },
    { path: '/vehicles', icon: Car, label: 'Véhicules' },
    { path: '/vehicles/sold', icon: CheckCircle2, label: 'Véhicules vendus' },
    { path: '/vehicles/new', icon: PlusCircle, label: 'Ajouter véhicule' },
  ];

  const handleLogout = async () => {
    await logout();
    toast.success('Déconnecté');
    navigate('/login', { replace: true });
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-slate-50 flex flex-col shadow-2xl">
      <div className="p-6 border-b border-slate-700/50">
        <div className="flex flex-col items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_auto-flip-tracker-1/artifacts/mote16qp_26609.jpg"
            alt="Groupe Auto Prestige"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>

      <nav className="flex-1 p-4">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          return (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`sidebar-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`sidebar-link flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive ? 'active' : ''}`}
            >
              <Icon size={20} />
              <span className="font-medium">{link.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-700/50 bg-slate-900/50 space-y-3">
        {user && user.email && (
          <div className="flex items-center gap-2 px-2 text-xs text-slate-400 truncate" data-testid="sidebar-user-email">
            <User size={14} />
            <span className="truncate" title={user.email}>{user.email}</span>
          </div>
        )}
        <button
          onClick={handleLogout}
          data-testid="sidebar-logout-btn"
          className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-red-600/90 hover:bg-red-600 text-white rounded-md text-sm font-medium transition-colors shadow"
        >
          <LogOut size={16} />
          <span>Se déconnecter</span>
        </button>
        <p className="text-slate-500 text-xs text-center">© 2026 Groupe Auto Prestige</p>
      </div>
    </aside>
  );
};

export default Sidebar;
